export default "__VITE_ASSET__BrZ13Lzw__"